import admin from '@Features/admins/adminSlice';
import { AdminState } from '@Features/admins/adminSlice.types';
import auth from '@Features/auth/authSlice';
import { AuthState } from '@Features/auth/authSlice.types';
import classroom from '@Features/classrooms/classroomSlice';
import roles from '@Pages/Roles/Features/rolesSlice';
import { ClassroomSliceState } from '@Features/classrooms/classroomSlice.types';
import newsFeed from '@Pages/NewsFeeds/Slices/NewsFeedSlice';
import { PermissionState } from '@Features/permissions/permissionSlice.types';
import { StudentSliceState } from '@Features/students/studentSlice.types';
import { CategoriesState } from '@Pages/Categories/Slices/CategoriesSlice.Types';
import { InvoiceState } from '@Features/invoices/invoicesSlice.types';
import { Action, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import student from '@Features/students/studentSlice';
import walletCodes from '@Features/walletCodes/walletCodesSlice';
import permission from '@Features/permissions/permissionSlice';
import instructor from '@Pages/Instructors/Slices/instructorsSlice';
import category from '@Pages/Categories/Slices/CategoriesSlice';
import invoice from '@Features/invoices/invoicesSlice';
import classroomTabs from '@Features/classrooms/tabsSlice';
import { NewsFeedState } from '@Pages/NewsFeeds/Slices/NewsFeedSlice.Types';
import { ScratchCardsState } from './scratchCards/scratchCardsSlice.types';
import scratchCard from '@Features/scratchCards/scratchCardsSlice';
import { SettingsState } from './settings/settingsSlice.types';
import settings from './settings/settingsSlice';
import educational, { educationalState } from './classrooms/educationalSlice';
import analysis, { EnrolledAnalysisState } from './classrooms/EnrolledSlice';
import { NotificationsStateType as NotificationsSliceState } from '@Features/notifications/notificationsSlice.types';
import { AdmissionFormStateType } from '@Features/classrooms/admissionFormSlice.types';
import classroomAdmissionForm from '@Features/classrooms/admissionFormSlice';
import dropdowns from '@Features/dropdowns/dropdownsSlice';
import { DropdownsState } from '@Features/dropdowns/dropdownsSlice.types';
import { InitialStateType as ClassroomTabsSliceState } from './classrooms/tabsSlice.types';
import notifications from '@Features/notifications/notificationsSlice';
import { WalletCodesState } from './walletCodes/walletCodesSlice.types';
import exports, { ExportClassroomsState } from './classrooms/exportSlice';
import { IPsState } from './IPs/ipSlice.types';
import IPs from './IPs/ipsSlice';
import { ClassroomAdmissionResponse } from '@Pages/ClassRooms/Types/ClassroomAdmission.types';
import { Course, Tab } from '@Pages/ClassRooms/Types/ClassroomTabs.types';
import ClassroomTabs from '@Pages/ClassRooms/Slices/ClassroomTabs/ClassroomTabs.slice';
import { RolesSliceState } from '@Pages/Roles/Features/roleSilce.types';
import { Admin } from '@Pages/Admin/Types/admin.types';
import { AdminSlice } from '@Pages/Admin/Slice/AdminSlice';
import {
	LoadingReducer,
	LoadingState,
} from '@Providers/LoadingProvider/Reducer/LoadingReducer';
import { InstructorSliceState } from '@Pages/Instructors/Slices/instructorsSlice.types';
import { RechargeCodesSlice } from '@Pages/RechargeCodes/Slices/RechargeCodes.slice';
import { RechargeCode } from '@Pages/RechargeCodes/Types/RechargeCodes.types';
import { BaseSliceState } from '@Types/slices';
import { ScratchCardsSlice } from '@Pages/ScratchCards/Slices/ScratchCards.slice';
import { ScratchCard } from '@Pages/ScratchCards/Types/ScratchCards.types';
import { InstructorCodesSlice } from '@Pages/InstructorCodes/Slices/InstructorCodes.slice';
import { InstructorCode } from '@Pages/InstructorCodes/Types/InstructorCodes.types';
import {
	Slot,
	RegisteredUser,
	Webinar,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Webinar/Types/Webinar.types';

import {
	Test,
	TestNotification,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Types/Test/Test.types';
import { TestSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Slice/TestSlice';
import {
	Tag,
	TestQuestion,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Types/TestQuestion';
import { TestQuestionsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Slice/TestQuestions/TestQuestionsSlice';
import { TagsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Slice/Tags/TagsSlice';
import { Invoice } from '@Pages/Invoices/Types/Invoices.types';
import { InvoicesSlice } from '@Pages/Invoices/Slices/Invoices.slice';
import { WebinarSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Webinar/Slices/Webinar.slice';
import { RegisteredUsersSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Webinar/Slices/Registered.slice';
import { Document } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Documents/Types/Documents.types';
import { DocumentsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Documents/Slices/Documents.slice';
import { Content } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Web Content/Types/WebContent.types';
import { webContentSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Web Content/Slice/WebContent.slices';
import { Unit } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Contents/Types/Units.types';
import { UnitSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Contents/Slices/Units.slice';
import { WebinarSlotSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Webinar/Slices/Slot.slice';
import { TestModel } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Types/TestModel.types';
import { TestModelSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Slice/TestModel/TestModel.slice';
import {
	SingleStudentData,
	Courses,
	SingleStudentResponse,
	walletLog,
	ClassRoom,
	Course as CourseTab,
	TimelineLog,
} from '@Services/students/students.res.types';
import { VideoType } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/VideoUnit/Types/Video.types';
import { VideoUnitSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/VideoUnit/Slices/Video.slice';
import { SequenceManagement } from '@Pages/ClassRooms/Pages/SingleClassroom/Components/SequenceManagement/types/sequence.types';
import { SequenceManagementSlice } from '@Pages/ClassRooms/Pages/SingleClassroom/Components/SequenceManagement/Slice/Sequence.slice';
import { EnrolledUser } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/Users/Types/UserProgress.types';
import { UserUnitsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/Users/Slice/users.Slice';
import { UsersRequester } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/Users/Services/Userprogress/UserProgressRequester';
import { StudentsSlice } from '@Pages/Students/Slice/Students.Slice';
import { CoursesTabSlice } from '@Pages/Students/StudentTabs/Courses/Slices/CourseTab.Slices';
import { WalletLogsSlice } from '@Pages/Students/StudentTabs/Wallet/Slices/WalletLogs.Slices';
import { ClassRoomTabSlice } from '@Pages/Students/StudentTabs/ClassRooms/Slices/ClassRoomsTab.Slices';
import { Import } from '@Pages/Imports/Types/Imports.types';
import { ImportsSlice } from '@Pages/Imports/Slice/Imports.slice';
import { InvoicesTabSlice } from '@Pages/Students/StudentTabs/Invoices/Slices/Invoices.Slice';
import { RechargeCodeTabSlice } from '@Pages/Students/StudentTabs/RechargeCodes/Slices/RechargeCode.Slices';
import { ScratchCodeTabSlice } from '@Pages/Students/StudentTabs/ScratchCards/Slices/ScratchCards.Slice';
import { TimelineTabSlice } from '@Pages/Students/StudentTabs/Timeline/Slices/Timeline.Slices';
import { TestNotificationSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Slice/TestNotifaction/TestNotifaction.slice';
import {
	CourseSingleTest,
	CourseTestsSummary,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Types/TestReports.types';
import { TestsReportsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Slices/TestsReports.slice';
import { SingleTestReportSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Slices/SingleTestReport.slice';
import { AttendanceReportSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Slices/AttendanceReport.slice';
import { AttendanceCheckinRow } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Types/AttendanceReport.types';
import { TestSummarySlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Slices/TestSummary.slice';
import { Attempt } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Components/Tests/Components/TestSummary/TestSummary.types';
import courseOverviewSlice, {
	CourseOverviewReportState,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseReports/Slices/ReportOverview.slice';
import {
	StudentTestsPayload,
	TestsCount,
} from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Tests/Types/Tests.types';
import { StudentTestsCountSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Tests/Slices/TestsCountSlices';
import { StudentTestsSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Tests/Slices/StudentTestsSlice';
import { WebinarsCountSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Webinars/Slices/WebinarsCount.slice';
import {
	StudentWebinarAnalytic,
	StudentWebinarsCount,
} from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Webinars/Types/StudentWebinars.types';
import { StudentWebinarsSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Webinars/Slices/StudentWebinars.slice';
import { Device } from '@Pages/Students/StudentTabs/Devices/Types/StudentDevices.types';
import { StudentDevicesSlice } from '@Pages/Students/StudentTabs/Devices/Slices/StudentDevices.slice';
import { Assistants } from '@Pages/Instructors/Types/Instructor.types';
import { AssistantsSlice } from '@Pages/Instructors/Slices/Assistants.Slice';
import { AssignmentsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Assignment/Slices/Assignment.Slice';
import { Assignments } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Assignment/Types/Assignment.types';
import { StudentAttendancesSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Attendances/Slices/StudentTestsSlice';
import {
	AttendancesCount,
	AttendancesPayload,
} from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Attendances/Types/Attendaces.types';
import { StudentAttendancesCountSlice } from '@Pages/Students/StudentTabs/ClassRooms/Pages/Components/Attendances/Slices/TestsCountSlices';
import { AppSettingsSlice } from '@Pages/Settings/Slices/AppSettings.slices';
import { AppSetting } from '@Pages/Settings/Types/AppSetting.types';
import { Group } from '@Pages/ClassRooms/Types/Groups.types';
import { GroupsSlice } from '@Pages/ClassRooms/Slices/Groups/Groups.slice';
import { GroupStudentsSlice } from '@Pages/ClassRooms/Slices/GroupStudents/GroupStudents.slice';
import { NotesSlice } from '@Pages/Instructors/Pages/Assistants copy/Slices/Notes.Slices';
import { Note } from '@Pages/Instructors/Pages/Assistants copy/Types/Notes.types';
import {
	PromoCode,
	PromoCodesUsage,
} from '@Pages/PromoCodes/Types/PromoCodes.types';
import { PromoCodessSlice } from '@Pages/PromoCodes/Slices/PromoCodes.slice';
import { PromoCodesUsageSlice } from '@Pages/PromoCodes/Slices/PromoCodesUsage.slice';
import { TestImport } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Pages/TestImports/Types/Imports.types';
import { TestImportsSlice } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Pages/TestImports/Slice/Imports.slice';
import videoImports, {
	VideoImportsState,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/FilesTab/Slices/VideoImports.slice';
import videoProviderSettings, {
	VideoProviderSettingsState,
} from '@Pages/Settings/VideoProviders/Slices/VideoProviderSettings.slice';

export interface RootState {
	auth: AuthState;
	student: StudentSliceState;
	Students: BaseSliceState<SingleStudentData>;
	CoursesTab: BaseSliceState<CourseTab>;
	InvoicesTab: BaseSliceState<Invoice>;
	RechargeCodeTab: BaseSliceState<RechargeCode>;
	ScratchCodeTab: BaseSliceState<ScratchCard>;
	TimelineTab: BaseSliceState<TimelineLog>;
	WalletLogs: BaseSliceState<walletLog>;
	ClassRoomTab: BaseSliceState<ClassRoom>;
	Assistants: BaseSliceState<Assistants>;
	admin: AdminState;
	permission: PermissionState;
	newsFeed: NewsFeedState;
	IPs: IPsState;
	scratchCard: ScratchCardsState;
	classroom: ClassroomSliceState;
	roles: RolesSliceState;
	educational: educationalState;
	analysis: EnrolledAnalysisState;
	exports: ExportClassroomsState;
	classroomTabs: ClassroomTabsSliceState;
	instructor: InstructorSliceState;
	category: CategoriesState;
	invoice: InvoiceState;
	settings: SettingsState;
	dropdowns: DropdownsState;
	notifications: NotificationsSliceState;
	classroomAdmissionForm: AdmissionFormStateType;
	walletCodes: WalletCodesState;
	ClassroomTabs: BaseSliceState<Tab>;
	Admins: BaseSliceState<Admin>;
	EnrolledUsersUnits: BaseSliceState<EnrolledUser>;
	Webinars: BaseSliceState<Webinar>;
	Slots: BaseSliceState<Slot>;
	StudentTestsCount: BaseSliceState<TestsCount>;
	StudentAttendancesCount: BaseSliceState<AttendancesCount>;
	StudentTests: BaseSliceState<StudentTestsPayload>;
	StudentAttendances: BaseSliceState<AttendancesPayload>;
	WebContents: BaseSliceState<Content>;
	RegisteredUsers: BaseSliceState<RegisteredUser>;
	TestsReports: BaseSliceState<CourseTestsSummary>;
	SingleTestReport: BaseSliceState<CourseSingleTest>;
	AttendanceReport: BaseSliceState<AttendanceCheckinRow>;
	VideoUnit: BaseSliceState<VideoType>;
	SequenceManagement: BaseSliceState<SequenceManagement>;
	TestSummary: BaseSliceState<Attempt>;
	Loading: LoadingState;
	RechargeCodes: BaseSliceState<RechargeCode>;
	ScratchCards: BaseSliceState<ScratchCard>;
	InstructorCodes: BaseSliceState<InstructorCode>;
	Tests: BaseSliceState<Test>;
	TestQuestions: BaseSliceState<TestQuestion>;
	TestNotification: BaseSliceState<TestNotification>;
	Tags: BaseSliceState<Tag>;
	Invoices: BaseSliceState<Invoice>;
	Documents: BaseSliceState<Document>;
	Units: BaseSliceState<Unit>;
	TestModels: BaseSliceState<TestModel>;
	Imports: BaseSliceState<Import>;
	TestImports: BaseSliceState<TestImport>;
	VideoImports: VideoImportsState;
	VideoProviderSettings: VideoProviderSettingsState;
	CourseReports: CourseOverviewReportState;
	StudentWebinarsCount: BaseSliceState<StudentWebinarsCount>;
	StudentWebinars: BaseSliceState<StudentWebinarAnalytic>;
	StudentDevices: BaseSliceState<Device>;
	Assignments: BaseSliceState<Assignments>;
	AppSetting: BaseSliceState<AppSetting>;
	Groups: BaseSliceState<Group>;
	GroupStudents: BaseSliceState<GroupStudent>;
	Notes: BaseSliceState<Note>;
	PromoCodes: BaseSliceState<PromoCode>;
	PromoCodesUsage: BaseSliceState<PromoCodesUsage>;
}

const rootReducer = {
	auth,
	student,
	admin,
	permission,
	newsFeed,
	IPs,
	scratchCard,
	classroom,
	roles,
	educational,
	analysis,
	exports,
	instructor,
	category,
	invoice,
	settings,
	dropdowns,
	classroomTabs,
	notifications,
	classroomAdmissionForm,
	walletCodes,
	ClassroomTabs,
	Admins: AdminSlice.getInstance().getReducer(),
	EnrolledUsersUnits: UserUnitsSlice.getInstance().getReducer(),
	Webinars: WebinarSlice.getInstance().getReducer(),
	Slots: WebinarSlotSlice.getInstance().getReducer(),
	StudentTestsCount: StudentTestsCountSlice.getInstance().getReducer(),
	StudentAttendancesCount:
		StudentAttendancesCountSlice.getInstance().getReducer(),
	StudentTests: StudentTestsSlice.getInstance().getReducer(),
	StudentAttendances: StudentAttendancesSlice.getInstance().getReducer(),
	AppSetting: AppSettingsSlice.getInstance().getReducer(),
	TestSummary: TestSummarySlice.getInstance().getReducer(),
	WebContents: webContentSlice.instance.getReducer(),
	RegisteredUsers: RegisteredUsersSlice.getInstance().getReducer(),
	Students: StudentsSlice.getInstance().getReducer(),
	CoursesTab: CoursesTabSlice.getInstance().getReducer(),
	InvoicesTab: InvoicesTabSlice.getInstance().getReducer(),
	RechargeCodeTab: RechargeCodeTabSlice.getInstance().getReducer(),
	ScratchCodeTab: ScratchCodeTabSlice.getInstance().getReducer(),
	TimelineTab: TimelineTabSlice.getInstance().getReducer(),
	TestsReports: TestsReportsSlice.getInstance().getReducer(),
	SingleTestReport: SingleTestReportSlice.getInstance().getReducer(),
	AttendanceReport: AttendanceReportSlice.getInstance().getReducer(),
	WalletLogs: WalletLogsSlice.getInstance().getReducer(),
	ClassRoomTab: ClassRoomTabSlice.getInstance().getReducer(),
	Assistants: AssistantsSlice.getInstance().getReducer(),
	SequenceManagement: SequenceManagementSlice.instance.getReducer(),
	VideoUnit: VideoUnitSlice.getInstance().getReducer(),
	Loading: LoadingReducer,
	RechargeCodes: RechargeCodesSlice.getInstance().getReducer(),
	ScratchCards: ScratchCardsSlice.getInstance().getReducer(),
	InstructorCodes: InstructorCodesSlice.getInstance().getReducer(),
	Tests: TestSlice.instance.getReducer(),
	TestQuestions: TestQuestionsSlice.instance.getReducer(),
	Tags: TagsSlice.instance.getReducer(),
	Invoices: InvoicesSlice.getInstance().getReducer(),
	Documents: DocumentsSlice.instance.getReducer(),
	Units: UnitSlice.instance.getReducer(),
	TestModels: TestModelSlice.instance.getReducer(),
	Imports: ImportsSlice.getInstance().getReducer(),
	TestImports: TestImportsSlice.getInstance().getReducer(),
	VideoImports: videoImports,
	VideoProviderSettings: videoProviderSettings,
	TestNotification: TestNotificationSlice.instance.getReducer(),
	CourseReports: courseOverviewSlice,
	StudentWebinarsCount: WebinarsCountSlice.instance.getReducer(),
	StudentWebinars: StudentWebinarsSlice.instance.getReducer(),
	StudentDevices: StudentDevicesSlice.getInstance().getReducer(),
	Assignments: AssignmentsSlice.getInstance().getReducer(),
	Groups: GroupsSlice.getInstance().getReducer(),
	GroupStudents: GroupStudentsSlice.getInstance().getReducer(),
	Notes: NotesSlice.getInstance().getReducer(),
	PromoCodes: PromoCodessSlice.getInstance().getReducer(),
	PromoCodesUsage: PromoCodesUsageSlice.getInstance().getReducer(),
};

const store = configureStore({
	reducer: rootReducer,
	middleware: (middleware) =>
		middleware({
			serializableCheck: false,
		}),
});

export default store;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;

export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>();
export declare type TRootState = ReturnType<typeof store.getState>;
